module.exports = __webpack_public_path__ + "img/1261055.853e925d.png";